// @flow
import crypto from 'crypto-js';

const SECRET_KEY = 'cacheby-shipping-tracking-secret-2024';

/**
 * orderId와 fulfillmentId를 조합하여 토큰 생성
 */
export function generateShippingToken(orderId: string, fulfillmentId: string): string {
  const data = `${orderId}:${fulfillmentId}`;
  const hash = crypto.HmacSHA256(data, SECRET_KEY)
    .toString(crypto.enc.Base64)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '')
    .substring(0, 28);
  
  return hash;
}



// WEBPACK FOOTER //
// ./src/lib/shippingToken.js